import { cookieUtil } from '../utils/cookies.util';

export type UserCookies = {
  analytics: boolean;
  essential: boolean;
  functional: boolean;
  marketing: boolean;
};

export const cookieSettingsStore = cookieUtil<UserCookies>('cookie-settings');
